import React, { useState, useEffect } from "react";
import WagerTypesConstants from "../../constants/WagerTypesConstants";
import WinPlaceShow from "../../wagerTypes/WinPlaceShow";
import Exacta from "../../wagerTypes/Exacta";
import Trifecta from "../../wagerTypes/Trifecta";
import Superfecta from "../../wagerTypes/Superfecta";
import DailyDouble from "../../wagerTypes/DailyDouble";
import Picks from "../../wagerTypes/Picks";
import WagerTypes from "../../constants/WagerTypes";
import Omni from "../../wagerTypes/Omni";
import High5 from "../../wagerTypes/High5";
import Quinella from "../../wagerTypes/Quinella";
import HouseQuinella from "../../wagerTypes/HouseQuinella";
import GrandSlam from "../../wagerTypes/GrandSlam";

const WagerTypesRace = ({
  raceInfo,
  entriesInfo,
  addToCart,
  ticketIndex,
  setTicketIndex,
  disabledAll,
  races,
  checkBoxState,
  setCheckBoxState,
  getEntriesRace,
  entriesPicks,
  setIndexTab,
  indexTab,
}) => {
  let wagerTypes = [],
    classActive = "";

  WagerTypesConstants.forEach((element) => {
    if (element.name === "Win") {
      wagerTypes.push({ [element.name]: true });
    } else {
      wagerTypes.push({ [element.name]: false });
    }
  });
  const [wagerTypeStatus, setWagerTypeStatus] = useState(wagerTypes);
  const [pickSelected, setPickSelected] = useState({});

  let wagerTypeTab = [];

  if (raceInfo) {
    WagerTypesConstants.forEach((e) => {
      classActive = "";
      if (wagerTypeStatus.find((item) => item[e.name])) {
        if (wagerTypeStatus.find((item) => item[e.name])[e.name]) {
          classActive = "active show";
        }
      }

      if (raceInfo[e.name] && raceInfo[e.name] === "true") {
        if (e.name !== "Place" && e.name !== "Show") {
          if (e.name === "Win" && raceInfo.Win === "true") {
            wagerTypeTab.push(
              <a
                className={"nav-link " + classActive}
                key={e.name}
                id={e.name + "-tab"}
                data-toggle="tab"
                href={"#" + e.name}
                role="tab"
                aria-controls="home"
                aria-selected="true"
                onClick={() => displayEntries(e.name)}
              >
                Win/Place/Show
              </a>
            );
          } else {
            wagerTypeTab.push(
              <a
                className={"nav-link " + classActive}
                key={e.name}
                id={e.name + "-tab"}
                data-toggle="tab"
                href={"#" + e.name}
                role="tab"
                aria-controls="home"
                aria-selected="true"
                onClick={() => displayEntries(e.name)}
              >
                {e.name}
              </a>
            );
          }
        }
      }
    });
  }

  useEffect(() => {
    let wagerTypes = [];

    WagerTypesConstants.forEach((element) => {
      if (element.name === "Win") {
        wagerTypes.push({ Win: true });
      } else {
        wagerTypes.push({ [element.name]: false });
      }
    });

    setWagerTypeStatus(wagerTypes);
  }, [raceInfo]);

  const displayEntries = (wagerType) => {
    let wagerTypes = [];

    WagerTypesConstants.forEach((element) => {
      if (element.name === wagerType) {
        wagerTypes.push({ [element.name]: true });
      } else {
        wagerTypes.push({ [element.name]: false });
      }
    });

    setWagerTypeStatus(wagerTypes);

    if (wagerType.includes("Pick")) {
      setPickSelected(wagerType);
      getEntriesRace(
        raceInfo.RaceID,
        parseInt(wagerType.replace("Pick", "")),
        raceInfo.RaceStatus
      );
    }

    if (wagerType.includes("DailyDouble")) {
      getEntriesRace(raceInfo.RaceID, 2, raceInfo.RaceStatus);
    }

    if (wagerType.includes("GrandSlam")) {
      getEntriesRace(raceInfo.RaceID, 4, raceInfo.RaceStatus);
    }

    setTicketIndex(ticketIndex + 1);
    setIndexTab(indexTab + 1);
    setCheckBoxState(true);
  };
  let showPick = false;
  if (wagerTypeStatus.some((item) => item[pickSelected] === true)) {
    showPick = true;
  }

  return (
    <>
      <div className="itemTabs nav nav-tabs" id="myTab" role="tablist">
        {wagerTypeTab}
      </div>
      <div
        className="tab-content"
        id="myTabContent"
        style={{ paddingLeft: "15px", paddingRight: "15px" }}
      >
        {wagerTypeStatus.some((item) => item["Win"] === true) && (
          <WinPlaceShow
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idWin={WagerTypes.WIN.id}
            idPlace={WagerTypes.PLACE.id}
            idShow={WagerTypes.SHOW.id}
            addToCart={addToCart}
            setTicketIndex={setTicketIndex}
            ticketIndex={ticketIndex}
          />
        )}
        {wagerTypeStatus.some((item) => item["Exacta"] === true) && (
          <Exacta
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idExacta={WagerTypes.EXACTA.id}
            idBox={WagerTypes.EXACTABOX.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["Trifecta"] === true) && (
          <Trifecta
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idTrifecta={WagerTypes.TRIFECTA.id}
            idBox={WagerTypes.TRIFECTABOX.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["Superfecta"] === true) && (
          <Superfecta
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idSuperfecta={WagerTypes.SUPERFECTA.id}
            idBox={WagerTypes.SUPERFECTABOX.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["Omni"] === true) && (
          <Omni
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idOmni={WagerTypes.OMNI.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
          />
        )}
        {wagerTypeStatus.some((item) => item["High5"] === true) && (
          <High5
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idHigh5={WagerTypes.HIGH5.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["Quinella"] === true) && (
          <Quinella
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idQuinella={WagerTypes.QUINELLA.id}
            idBox={WagerTypes.QUINELLABOX.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["HouseQ"] === true) && (
          <HouseQuinella
            raceInfo={raceInfo}
            entriesInfo={entriesInfo}
            idHouseQ={WagerTypes.HOUSEQ.id}
            idBox={WagerTypes.HOUSEQBOX.id}
            addToCart={addToCart}
            disabledAll={disabledAll}
            checkBoxState={checkBoxState}
          />
        )}
        {wagerTypeStatus.some((item) => item["DailyDouble"] === true) && (
          <DailyDouble
            raceInfo={raceInfo}
            idDD={WagerTypes.DAILYDOUBLE.id}
            addToCart={addToCart}
            entries={entriesPicks}
          />
        )}
        {wagerTypeStatus.some((item) => item["GrandSlam"] === true) && (
          <GrandSlam
            raceInfo={raceInfo}
            idGrandSlam={WagerTypes.GRANDSLAM.id}
            addToCart={addToCart}
            entries={entriesPicks}
          />
        )}
        {showPick && (
          <Picks
            raceInfo={raceInfo}
            pickName={pickSelected}
            idPick={WagerTypes[pickSelected.toUpperCase()].id}
            addToCart={addToCart}
            entriesPicks={entriesPicks}
          />
        )}
      </div>
    </>
  );
};

export default WagerTypesRace;
